webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Panel__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Counter__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Panel: __WEBPACK_IMPORTED_MODULE_0__components_Panel__["a" /* default */],
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings__["a" /* default */],
    Counter: __WEBPACK_IMPORTED_MODULE_2__components_Counter__["a" /* default */]
  },
  data: function data() {
    return {
      settings: {
        pointsPerDay: 23,
        extraPoints: 23,
        cheatDay: 7,
        show: true
      }
    };
  },
  computed: {},
  methods: {
    updateSettings: function updateSettings(data) {
      this.settings.pointsPerDay = data.points;
      this.settings.extraPoints = data.extra;
      this.settings.cheatDay = data.cheat;
      this.settings.show = false;

      localStorage.settings_pointsPerDay = data.points;
      localStorage.settings_extraPoints = data.extra;
      localStorage.settings_cheatDay = data.cheat;
      localStorage.settings_show = 'no';
    }
  },
  mounted: function mounted() {
    if (localStorage.settings_pointsPerDay) {
      this.settings.pointsPerDay = localStorage.settings_pointsPerDay * 1;
    }
    if (localStorage.settings_extraPoints) {
      this.settings.extraPoints = localStorage.settings_extraPoints * 1;
    }
    if (localStorage.settings_cheatDay) {
      this.settings.cheatDay = localStorage.settings_cheatDay * 1;
    }
    if (localStorage.settings_show) {
      this.settings.show = localStorage.settings_show == 'yes';
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Panel",
  props: {
    headline: String
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Settings",
  props: {
    points: Number,
    extra: Number,
    cheat: Number
  },
  data: function data() {
    return {
      options: {
        cheats: [{ value: 0, label: 'Geen' }, { value: 1, label: 'Maandag' }, { value: 2, label: 'Dinsdag' }, { value: 3, label: 'Woensdag' }, { value: 4, label: 'Donderdag' }, { value: 5, label: 'Vrijdag' }, { value: 6, label: 'Zaterdag' }, { value: 7, label: 'Zondag' }]
      }
    };
  },
  computed: {
    cheatday: function cheatday() {
      return this.options.cheats[this.cheat];
    }
  },
  methods: {
    setCheat: function setCheat(value) {
      this.cheat = value.value;
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_swipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_swipe__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Counter",
    components: {
        Swipe: __WEBPACK_IMPORTED_MODULE_0_vue_swipe__["Swipe"],
        SwipeItem: __WEBPACK_IMPORTED_MODULE_0_vue_swipe__["SwipeItem"]
    },
    props: {
        points: Number,
        extra: Number,
        cheat: Number
    },
    data: function data() {
        return {
            swipeOptions: {
                continuous: false,
                auto: 10000000,
                showIndicators: false
            },
            timer: null,
            update_count: 0,
            current_day: -1,
            cache: {
                week: null,
                extra: 0,
                days: {}
            },
            options: {
                days: ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag', 'Zondag']
            }
        };
    },
    created: function created() {
        if (!this.timer) {
            this.timer = setInterval(this.restoreFromCache, 30000);
        }
    },
    computed: {
        remaining: function remaining() {
            this.update_count; // to trigger update
            var date = this.selectedDate();
            this.buildCache(date);
            return this.cache.days[this.getWeekDay(date)];
        },
        dayDescription: function dayDescription() {
            var day = this.getWeekDay(this.selectedDate());
            if (day == this.getWeekDay(new Date())) {
                return 'Vandaag';
            } else {
                return this.options.days[day - 1];
            }
        },
        defaultScreen: function defaultScreen() {
            if (this.current_day == -1) {
                return this.getWeekDay(new Date());
            } else {
                return this.current_day;
            }
        },
        days: function days() {
            this.update_count; // to trigger update
            this.buildCache(new Date());

            var today = this.getWeekDay(new Date());

            var result = {};
            for (var day = 1; day <= today; day++) {
                result[day] = {
                    description: today == day ? "Vandaag" : this.options.days[day - 1],
                    now: today == day,
                    isCheatDay: this.cheat == day,
                    remaining: this.cache.days[day]
                };
            }

            return result;
        }
    },
    methods: {
        clearAll: function clearAll() {
            localStorage.clear();
            location.reload();
        },
        reload: function reload() {
            location.reload();
        },
        storeToCache: function storeToCache() {
            localStorage.counter_week = this.cache.week;
            localStorage.counter_extra = this.cache.extra;
            localStorage.counter_day1 = this.cache.days[1];
            localStorage.counter_day2 = this.cache.days[2];
            localStorage.counter_day3 = this.cache.days[3];
            localStorage.counter_day4 = this.cache.days[4];
            localStorage.counter_day5 = this.cache.days[5];
            localStorage.counter_day6 = this.cache.days[6];
            localStorage.counter_day7 = this.cache.days[7];
        },
        restoreFromCache: function restoreFromCache() {
            this.update_count += 1;
            if (localStorage.counter_week) {
                this.cache.week = localStorage.counter_week;
                this.cache.extra = localStorage.counter_extra * 1;
                this.cache.days = {
                    1: localStorage.counter_day1 * 1,
                    2: localStorage.counter_day2 * 1,
                    3: localStorage.counter_day3 * 1,
                    4: localStorage.counter_day4 * 1,
                    5: localStorage.counter_day5 * 1,
                    6: localStorage.counter_day6 * 1,
                    7: localStorage.counter_day7 * 1
                };
            }
        },
        addPoint: function addPoint() {
            var date = this.selectedDate();
            this.buildCache(date);
            var week = this.getWeekNumber(date);
            var day = this.getWeekDay(date);

            if (this.cache.days[day] <= 0) {
                this.cache.extra -= 1;
            }
            this.cache.days[day] -= 1;
            this.update_count += 1; // to trigger update

            this.storeToCache();
        },
        buildCache: function buildCache(date) {
            var week = this.getWeekNumber(date);
            if (this.cache.week == null) {
                this.restoreFromCache();
            }
            if (this.cache.week != week) {
                this.cache.week = week;
                this.cache.extra = this.extra;
                this.cache.days = {
                    1: this.points,
                    2: this.points,
                    3: this.points,
                    4: this.points,
                    5: this.points,
                    6: this.points,
                    7: this.points
                };

                this.storeToCache();
            }
        },

        selectedDate: function selectedDate() {
            var now_day = this.getWeekDay(new Date());
            if (this.current_day == -1 || this.current_day > now_day) {
                this.current_day = now_day;
            }

            var date = new Date();
            date.setDate(date.getDate() - (this.current_day - this.getWeekDay(date)));
            return date;
        },
        getWeekDay: function getWeekDay(d) {
            var day = d.getDay();

            if (day == 0) {
                day = 7;
            }
            return day;
        },
        getWeekNumber: function getWeekNumber(d) {
            d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
            var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
            var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
            return d.getUTCFullYear() + '-' + weekNo;
        }
    }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("v-select", __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8633a5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(25);
function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8633a5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panel_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_641d1c42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panel_vue__ = __webpack_require__(16);
function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_641d1c42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"header"},[_c('h2',{staticClass:"headline"},[_vm._v(_vm._s(_vm.headline))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db6976f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(19);
function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db6976f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"settings"},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Punten per dag")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.points),expression:"points"}],staticClass:"input",attrs:{"type":"number"},domProps:{"value":(_vm.points)},on:{"input":function($event){if($event.target.composing){ return; }_vm.points=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Extra punten")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extra),expression:"extra"}],staticClass:"input",attrs:{"type":"number"},domProps:{"value":(_vm.extra)},on:{"input":function($event){if($event.target.composing){ return; }_vm.extra=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Vrije dag")]),_vm._v(" "),_c('v-select',{staticClass:"input-dropdown",attrs:{"value":_vm.cheatday,"options":_vm.options.cheats,"searchable":false,"clearable":false},on:{"input":_vm.setCheat}})],1),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('button',{staticClass:"submit-btn",on:{"click":function($event){return _vm.$emit('save', {points: _vm.points, extra: _vm.extra, cheat: _vm.cheat})}}},[_vm._v("Beginnen")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Counter_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48542ba3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Counter_vue__ = __webpack_require__(24);
function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Counter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48542ba3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Counter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swipe',{staticClass:"my-swipe",attrs:{"continuous":_vm.swipeOptions.continuous,"auto":_vm.swipeOptions.auto,"defaultIndex":_vm.defaultScreen,"showIndicators":_vm.swipeOptions.showIndicators}},[_c('swipe-item',[_c('div',{staticClass:"counter"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"submit-btn submit-reset",on:{"click":_vm.clearAll}},[_vm._v("Wis alle gegevens !")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"submit-btn",on:{"click":_vm.reload}},[_vm._v("Herladen")])])]),_vm._v(" "),_vm._l((_vm.days),function(day){return _c('swipe-item',[_c('div',{staticClass:"counter"},[_c('div',{staticClass:"date"},[_c('div',{staticClass:"day"},[_vm._v(_vm._s(day.description))]),_vm._v(" "),(day.isCheatDay)?_c('div',{staticClass:"cheat"},[_vm._v("VRIJE DAG")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!day.isCheatDay),expression:"!day.isCheatDay"}]},[_c('div',{staticClass:"count"},[_c('label',[_vm._v("Resterend:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(day.remaining))])]),_vm._v(" "),_c('div',{staticClass:"action"},[(day.now)?_c('button',{staticClass:"submit-btn",on:{"click":_vm.addPoint}},[_vm._v("Gebruik punt")]):_vm._e()]),_vm._v(" "),(day.now)?_c('div',{staticClass:"extra"},[_vm._v("\n                  Extra punten: "+_vm._s(_vm.cache.extra)+"\n                ")]):_vm._e()])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('panel',{attrs:{"headline":"Puntenboeker"}},[(_vm.settings.show)?_c('settings',{attrs:{"points":_vm.settings.pointsPerDay,"extra":_vm.settings.extraPoints,"cheat":_vm.settings.cheatDay},on:{"save":function($event){return _vm.updateSettings($event)}}}):_vm._e(),_vm._v(" "),(!_vm.settings.show)?_c('counter',{attrs:{"points":_vm.settings.pointsPerDay,"extra":_vm.settings.extraPoints,"cheat":_vm.settings.cheatDay}}):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.202a947c6567f3728263.js